<template>
  <div>
    <v-container>
      <h3 class="d-block text-center" style="color: #434343; padding: 8px">
        <!-- Information of Directors -->
      </h3>
      <v-form ref="formShareholders">
        <v-row
          class="ma-0"
          v-for="(shareholder, index) in shareholders"
          :key="index"
        >
          <v-col cols="12">
            <h3 class="mb-4 text-center" style="color: #434343">
              Shareholder {{ index + 1 }} Details
              <v-icon
                class="ml-2"
                @click="deleteShareHolder(shareholder)"
                v-if="index != 0"
              >
                mdi-delete</v-icon
              >
            </h3>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Percentage of Company Ownership
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.percentage"
              color="#434343"
              outlined
              placeholder="Enter Percentage of Company Ownership"
              maxlength="51"
              :rules="TextRules"
              label=""
              dense
              type="number"
              name="shareholder_company_ownershop"
              id="shareholder_company_ownershop"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >First Name
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.first_name"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter First Name"
              maxlength="51"
              label=""
              dense
              name="shareholder_first_name"
              id="share_first_name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Last Name
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.last_name"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter Last Name"
              maxlength="51"
              label=""
              dense
              name="shareholder_last_name"
              id="shareholder_last_name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Date of Birth
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-menu
              :value="modal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="shareholder.date_of_birth"
                  :rules="[(v) => !!v || 'Required']"
                  label=""
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  placeholder="Enter Date of Birth "
                  v-bind="attrs"
                  v-on="on"
                  name="shareholder_dob"
                  id="shareholder_dob"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="shareholder.date_of_birth"
                @input="modal = false"
                :max="todayDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Passport Number
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.passport_no"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter Passport Number"
              maxlength="51"
              label=""
              dense
              name="shareholder_passport_no"
              id="shareholder_passport_no"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Country of Passport
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.passport_country"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter Country of Passport"
              maxlength="51"
              label=""
              dense
              name="shareholder_passport_country"
              id="shareholder_passport_country"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Residing Street Address
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.residing_address"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter Residing Street Address"
              maxlength="51"
              label=""
              dense
              name="shareholder_residing_address"
              id="shareholder_residing_address"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >City <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.city"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter City "
              maxlength="51"
              label=""
              dense
              name="shareholder_city"
              id="shareholder_city"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Country <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.country"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter Country"
              maxlength="51"
              label=""
              dense
              name="shareholder_country"
              id="shareholder_country"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Postal Code
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.postal_code"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter Postal Code"
              maxlength="51"
              label=""
              dense
              name="shareholder_postal_code"
              id="shareholder_postal_code"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Relative or Public Post
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="shareholder.relative_public_figure"
              :rules="TextRules"
              color="#434343"
              outlined
              placeholder="Enter Relative or Public Post"
              maxlength="51"
              label=""
              dense
              name="shareholder_relative_public_post"
              id="shareholder_relative_public_post"
            >
            </v-text-field>
          </v-col>
          <!-- <v-col cols="6">
          <br>
            <span class="caption font-weight-medium">
              DO YOU OR ANY OF YOUR RELATIVES HOLD A POLITICAL OR PUBLIC<br />POST
              OR HAVE YOU IN THE PAST?
            </span>
            <br />
           
            &nbsp;
            <v-checkbox dense class="float-left" color="#434343" v-model="shareholder.is_applicable">
              <template v-slot:label>
                <span class="">Yes</span>
              </template>
            </v-checkbox>
            &nbsp;
            <v-text-field
              dense
              v-model="shareholder.applicable"
              color="#434343"
              placeholder="if yes please specify"
              class="mt-n5 specify-reason "
            >
            </v-text-field>
          </v-col> -->
          <v-col cols="6" class="mt-6">
            <v-checkbox
              v-model="shareholder.is_US_resident"
              :label="`Resident of United States?`"
              class="mt-2"
              color="#434343"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
      <v-icon @click="addShareHolder()" class="ml-1"> mdi-plus-thick </v-icon>
      <v-btn
        @click="updateShareholders()"
        class="mb-2 float-end next-btn appBlue white--black ml-2"
      >
        Next
      </v-btn>
      <v-btn
        text
        @click="updateIndex(3)"
        class="mb-2 float-end mx-1 next-btn liteGray black--text"
        >Previous</v-btn
      >
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      shareholders: [],
      TextRules: [(v) => !!v || "Required"],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      modal: false,
      today:"",
    };
  },
  computed: {
    ...mapGetters(["getFormId", "getUserId"]),
  },
  mounted() {
    let today = new Date();
    this.todayDate = today.toISOString().slice(0, 10);
    this.getShareHolder();
    // this.TextRules.push((v) => v.length <= 50 || "Max 50 characters");
  },
  methods: {
    // get share holders
    getShareHolder() {
      axios
        .post(
          "/shareholdersDetail",
          {
            user_id: this.getUserId,
            form_id: this.getFormId,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.shareholders = res.data.shareholderDetail;
        })
        .catch((err) => {
          console.log(err, "share mount err");
        });
    },
    // add more share holder
    addShareHolder() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "/createShareholderId",
            {
              user_id: this.getUserId,
              form_id: this.getFormId,
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            resolve(res);
            // console.log(res.data, "add new share");
            this.shareholders.push(res.data.shareholder);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "add new share er");
          });
      });
    },
    // Update Share holders
    updateShareholders() {
      if (!this.$refs.formShareholders.validate()) {
        this.$store.dispatch("updateShareholdersDetailsError", true);
        this.shareholdersError = !true;
      } else {
        this.$store.dispatch("updateShareholdersDetailsError", !true);
        this.shareholdersError = true;
      }
      axios
        .post(
          "/createShareholder",
          {
            shareholderDetails: this.shareholders,
            form_id: this.getFormId,
            user_id: this.getUserId,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          // console.log(res.data, "shareholders");
        })
        .catch((err) => {
          console.log(err.response, "share err");
        });
      this.updateIndex(5),
        // this.$store.dispatch("updateShareholderDetails", this.shareholders);
        this.$store.dispatch("incrementStepper");
    },
    // delete share holder
    deleteShareHolder(shareholder) {
      this.shareholders.filter((item) => {
        if (item.id == shareholder.id) {
          this.deleteShareHolderId = shareholder.id;
        }
      });

      axios
        .post(
          "/deleteShareholder",
          {
            id: this.deleteShareHolderId,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.getShareHolder();
        })
        .catch((err) => {
          console.log(err, "deleted err");
        });
    },
    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    },
  },
};
</script>

<style>
</style>